import { HeadlineItem } from '../Card';
import React from 'react';

import { HeadlineItemsFragment } from '../../generated/graphql';
import { headlineItemRoute } from '../../helpers/routes';
import { ItemProps } from './common';
import { PageItemLink } from '../PageItemLink';

type size = 'large' | 'small';

const Headline: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const headline = item as HeadlineItemsFragment;

  return (
    <PageItemLink
      to={headlineItemRoute(page.id, headline.id, preview)}
      page={page}
      pageItem={item}
      data-testid={`headline-item-${headline.id}`}
    >
      <HeadlineItem
        text={headline.title || ''}
        size={(headline.style as size) || 'large'}
        header={headline.style === 'small' ? 'Small Title' : 'Large Title'}
        className={className}
        {...dragProps}
      />
    </PageItemLink>
  );
};

export default Headline;
